const PageHome = {

    template: `
        <div>
            <h1>Home</h1>
        </div>
    `
}